<template lang="pug"></template>

<script>
export default {
    name: 'BotaoInteligencia',
    componentOptions: {
        title: 'Inteligência',
        actions: [
            [
                {
                    name: 'Inteligência',
                    iconClass: 'lyra-icon lyra-ia',
                    showView: false,
                    action: 'abrirInteligencia',
                    route: 'Inteligencia'
                }
            ]
        ]
    },

    methods: {
        abrirInteligencia() {
            if (this.$route.name !== 'Inteligencia') {
                this.$router.push({ name: 'Inteligencia' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
